import React from "react";

const statusStyles = {
  active: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  ativo: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  paid: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  pago: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",

  pending: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  pendente: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  trial: "bg-blue-500/10 text-blue-400 border-blue-500/20",
  em_teste: "bg-blue-500/10 text-blue-400 border-blue-500/20",

  inactive: "bg-gray-500/10 text-gray-400 border-gray-500/20",
  inativo: "bg-gray-500/10 text-gray-400 border-gray-500/20",
  cancelled: "bg-rose-500/10 text-rose-400 border-rose-500/20",
  cancelado: "bg-rose-500/10 text-rose-400 border-rose-500/20",
  overdue: "bg-rose-500/10 text-rose-400 border-rose-500/20",
  vencido: "bg-rose-500/10 text-rose-400 border-rose-500/20",
  error: "bg-rose-500/10 text-rose-400 border-rose-500/20",

  default: "bg-purple-500/10 text-purple-400 border-purple-500/20"
};

const StatusBadge = ({ status, label }) => {
  const normalized = (status || label || "").toString().toLowerCase().replace(/[\s-]/g, "_");
  const style = statusStyles[normalized] || statusStyles.default;

  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-bold tracking-wider uppercase border ${style}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current mr-1.5 opacity-80" />
      {label || status}
    </span>
  );
};

export default StatusBadge;
